import {
    GET_ALL_IMAGES
} from './constants';

const initialState = {
    images: [],
};

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_ALL_IMAGES: {
            return {
                ...state,
                images: action.payload,
            };
        }
        default:
            return state;
    }
};

